import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";
import { DeliveryFeeListItem } from "../../financial.types";

export const requestDeliveryFees = async (
  params: GetListRequestParams
): Promise<GetListResponse<DeliveryFeeListItem>> => {
  return await instance.get(ApiRoutesDeliveryFees.DeliveryFees, {
    params
  });
};
